<template>
  <input
      v-tooltip="{content: msg, show: validationEmail, trigger: 'manual',placement: item.tooltip ? item.tooltip.placement  : 'right',}"
      type="email"
      v-model="item.values"
      class="table-email"
      :class="item.class"
      :disabled="item.disabled"
  >
</template>
<script>
    import { email } from 'vuelidate/lib/validators'
    export default {
        props: [ 'item' ],
        data() {
            return {
                patientList : this.$store.state.patientList,
                msg : ''
            }
        },
        validations: {
            item: {
                values: {
                    email
                }
            }
        },
        methods: {
          overlapCheck() {
            if (this.patientList.length > 0) {
                for (const patient of this.patientList) {
                  if (patient.patientEmail === this.item.values) {
                    this.msg = this.$t('account.email_already_exist');
                    return false
                  }
                }
            }
            return true
          },
          wrongEmailMsg() {
            this.msg = this.$t('account.email_form_mismatch');
          }
        },
        computed : {
          validationEmail() {
            // 멜 형식이 올바르거나,공백이면 false, 틀리면 true를 return
            // this.item.values = 사용자가 입력한 이메일
            if (this.item.values === undefined || this.item.values === '' || this.item.values.length <= 5) {
              return false;
            }

            // 등록하려는 이메일이 의사(치료사?)와 동일한 이메일의 경우 중복 알림으로 대체
            if (this.item.values === localStorage.getItem('userEmail')) {
              this.msg = this.$t('account.email_already_exist');
              return true;
            }

            // this.$v.item.values.email = 이메일 형식 검사 후 true, false 반환
            if (this.$v.item.values.email) {
              if (this.item?.overlap) { // 이멜 형식이 맞으나, 중복검사를 원하는 경우
                // 중복된 이메일의 경우
                return !this.overlapCheck();
              } else { // 이메일 형식이 맞고, 중복검사를 필요로 하지 않는 경우
                return false;
              }
            } else { // 이메일 형식부터 틀린 경우
              this.wrongEmailMsg();
              return true;
            }
          }
        }
    }
</script>
<style lang="scss">
.table-email:focus {
    border: 1px solid var(--blue70);
}

.table-email:disabled {
  background-color: var(--grey10) !important;
}
</style>